import { useCallback } from "react";

export function insertEmojiAtTextareaCursor(textarea, messageInput, emoji, onMessageInputChange) {
  if (!textarea) {
    onMessageInputChange(`${messageInput}${emoji}`);
    return;
  }

  const start = textarea.selectionStart ?? messageInput.length;
  const end = textarea.selectionEnd ?? messageInput.length;
  const nextValue = `${messageInput.slice(0, start)}${emoji}${messageInput.slice(end)}`;
  onMessageInputChange(nextValue);

  requestAnimationFrame(() => {
    textarea.focus();
    const cursor = start + emoji.length;
    textarea.setSelectionRange(cursor, cursor);
  });
}

export function useChatEmojiInsert({ messageInput, onMessageInputChange, textareaRef }) {
  return useCallback(
    (emoji) => {
      insertEmojiAtTextareaCursor(
        textareaRef.current,
        messageInput,
        emoji,
        onMessageInputChange
      );
    },
    [messageInput, onMessageInputChange, textareaRef]
  );
}
